module.exports = __webpack_public_path__ + "img/ltkxprime-3x.09e57aa.jpg";